module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-e96cd865.png";